import React from 'react';

/**
 * Process Selector Component
 * Allows user to select between full project scope or specific process scope for chat
 */
const ProcessSelector = ({ processes = [], selectedProcessId, onProcessChange, isLoading = false }) => {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="process-selector" className="text-sm font-medium text-gray-700 flex-shrink-0">
        Chat Scope:
      </label>
      <select
        id="process-selector"
        value={selectedProcessId || ''}
        onChange={(e) => onProcessChange(e.target.value || null)}
        disabled={isLoading || processes.length === 0}
        className="block flex-1 min-w-0 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="">Full Project (All Processes)</option>
        {processes.map((process) => (
          <option key={process.id} value={process.id}>
            {process.name}
            {process.technicalName && ` (${process.technicalName})`}
            {process.version && ` - v${process.version}`}
          </option>
        ))}
      </select>
      
      {processes.length === 0 && !isLoading && (
        <span className="text-xs text-gray-500">No processes available</span>
      )}
      
      {selectedProcessId && (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          Process Mode
        </span>
      )}
    </div>
  );
};

export default ProcessSelector;
